import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=621f47a3"
import script from "./DocumentUploader.vue?vue&type=script&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploader.vue?vue&type=style&index=0&id=621f47a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports